import api from "./axiosConfig";

export interface NotificationDto {
  id: string;
  tenantId: string;
  clientId?: string | null;
  clientName?: string | null;
  type: string;
  title: string;
  message: string;
  isRead: boolean;
  createdAt: string;
}

export const notificationsApi = {
  list: (unreadOnly = false, take = 30) =>
    api
      .get<NotificationDto[]>("/notifications", { params: { unreadOnly, take } })
      .then((r) => r.data),

  unreadCount: () => api.get<number>("/notifications/unread-count").then((r) => r.data),

  markRead: (id: string) => api.patch(`/notifications/${id}/read`),

  markAllRead: () =>
    api
      .patch<{ markedCount: number }>("/notifications/read-all")
      .then((r) => r.data),
};
